import { ColorCodes } from "./ColorCodes/ColorCodes";
import { SelectedColor } from "./SelectedColor/SelectedColor";
import { useColor } from "./useColor";

export const Color = () => {
    const { selectedColor } = useColor();
    if (!selectedColor) return null;
    return (
        <div className="px-4 flex flex-col gap-8">
            <SelectedColor selectedColor={selectedColor} />
            <ColorCodes selectedColor={selectedColor} />
        </div>
    );
};
